import { useState, forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import styles from './PasswordInput.module.css';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

/**
 * Input de password con toggle de visibilidad.
 *
 * Hereda el className recibido (típicamente la clase `field__input` del form)
 * para que tipográficamente coincida con el resto de campos. El botón del ojo
 * se posiciona absolutamente sobre el input.
 */
export const PasswordInput = forwardRef<HTMLInputElement, Props>(
  function PasswordInput({ className = '', ...rest }, ref) {
    const [visible, setVisible] = useState(false);
    return (
      <div className={styles.wrap}>
        <input
          ref={ref}
          type={visible ? 'text' : 'password'}
          className={`${className} ${styles.input}`}
          {...rest}
        />
        <button
          type="button"
          className={styles.toggle}
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
          aria-pressed={visible}
          tabIndex={-1}
        >
          {visible ? <EyeOff size={16} aria-hidden /> : <Eye size={16} aria-hidden />}
        </button>
      </div>
    );
  },
);
